import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

// MODULES/MODULOS  -------------------------------------------------------
import { AgmCoreModule } from '@agm/core';
import { RouterModule } from '@angular/router';

// COMPONENTS/COMPONENTES  ------------------------------------------------
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CitiesService } from '@asambleas-services/cities/cities.service';
import { FiltersByChurchesComponent } from '@asambleas-components/filters-by-churches/filters-by-churches.component';
import { UserService } from '@asambleas-services/user/user.service';
import { RoleAuthorizationDirective } from '@asambleas-directives/role-authorization.directive';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@asambleas-modules/material/material.module';
import { UserFeedbackModule } from '@asambleas-modules/user-feedback/user-feedback.module';
import { MapaIglesiasComponent } from '../../../app/admin/pages/iglesias/mapa-iglesias/mapa-iglesias.component';
import { AvatarPipe } from '@asambleas-pipes/avatar.pipe';
import { FullNamePipe } from '@asambleas-pipes/full-name.pipe';
import { SolicitarPersoneriaJuridicaComponent } from '@asambleas-components/solicitar-personeria-juridica/solicitar-personeria-juridica.component';

/**
 * Componentes que son compartidos por los otros modulos
 *
 * @export
 * @class ShareModule
 */
@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD8ZXnKF9EQwSV1XgZwGYTcn3NO4ItR9KU'
        }),
        UserFeedbackModule,
        FlexLayoutModule,
        RouterModule
    ],
    providers: [
        CitiesService
    ],
    declarations: [
        FiltersByChurchesComponent,
        RoleAuthorizationDirective,
        MapaIglesiasComponent,
        AvatarPipe,
        FullNamePipe,
        SolicitarPersoneriaJuridicaComponent
    ],
    exports: [
        FormsModule,
        AgmCoreModule,
        UserFeedbackModule,
        FlexLayoutModule,
        MaterialModule,
        FiltersByChurchesComponent,
        RoleAuthorizationDirective,
        MapaIglesiasComponent,
        AvatarPipe,
        FullNamePipe,
        SolicitarPersoneriaJuridicaComponent
    ]
})
export class ShareModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ShareModule,
            providers: [
                UserService
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/share/share.module.ts